/// <amd-module name="Repos/Tfvc/Views/FilesHub/RestClient/Tfvc" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\tfvc\views\files-hub\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Tfvc from "Repos/Common/Contracts/Git";

export interface ITfvcRestClient extends IVssRestClient {
    /**
     * Post for retrieving a set of items given a list of paths or a long path. Allows for specifying the recursionLevel and version descriptors for each path.
     * 
     * @param itemRequestData - 
     * @param project - Project ID or project name
     */
    getItemsBatch(itemRequestData: Tfvc.TfvcItemRequestData, project?: string): Promise<Tfvc.TfvcItem[][]>;
}

class TfvcRestClient extends RestClientBase implements ITfvcRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Post for retrieving a set of items given a list of paths or a long path. Allows for specifying the recursionLevel and version descriptors for each path.
     * 
     * @param itemRequestData - 
     * @param project - Project ID or project name
     */
    public async getItemsBatch(
        itemRequestData: Tfvc.TfvcItemRequestData,
        project?: string
        ): Promise<Tfvc.TfvcItem[][]> {

        return this.beginRequest<Tfvc.TfvcItem[][]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/tfvc/ItemBatch",
            routeValues: {
                project: project
            },
            body: itemRequestData
        });
    }

}

export const TfvcClientName = "Repos.FilesHub.Tfvc.ITfvcRestClient";

export function getTfvcClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITfvcRestClient {
    return pageContext.getRestClient<ITfvcRestClient>(TfvcClientName, options);
}

RestClients.add(TfvcClientName, { 
    factory: TfvcRestClient,
    options: {
        resourceAreaId: "8aa40520-446d-40e6-89f6-9c9f9ce44c48",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
